import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { EncounterAttendancePresentComponent } from '../components/encounter-attendance-present/encounter-attendance-present.component';

@Injectable({
  providedIn: 'root',
})
export class EncounterAttendancePresentDialogService {
  constructor(private dialogService: DialogService) {}

  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: EncounterAttendancePresentComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: EncounterAttendancePresentComponent,
      height: '80vh',
      minWidth: '1166',
      width: '80vw',
      cssClass: 'encounter-attendance-present',
    });

    // ComponentRef<EncounterAttendancePresentComponent>
    const content: ComponentRef<EncounterAttendancePresentComponent> =
      dialog.content as ComponentRef<EncounterAttendancePresentComponent>;
    const instance: EncounterAttendancePresentComponent = content.instance;

    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
